/* CRO 2026-11-04 – free Mesh Pouch gifts (approved by Tay).
   Owner: CRO agent. Own file; loaded from sections/cro-plus-gift.liquid (header group).
   Rule 1 "plus-pouch": GoLivUP Travel Pillow Plus in cart -> 1 x Black 15x20 pouch.
          Pairs with automatic discount "Free Mesh Pouch with Travel Pillow Plus" (100% off 1 x 15x20).
   Rule 2 "set-pouch":  Easy Rest Set / Deep Rest Set / Ultimate Rest Kit in cart -> 1 x Black 20x25 pouch.
          Pairs with automatic discount "Free Mesh Pouch (20 x 25 cm) with any Rest Set" (100% off 1 x Black 20x25).
   Per rule: trigger in cart + no pouch of that size -> add the gift with _gift=<rule>.
             Trigger gone -> remove the auto-added gift. Never more than one. Customer removal is respected (per session). */
(function () {
  'use strict';
  if (window.__croPlusGift) return; window.__croPlusGift = true;
  var RULES = [
    { id: 'plus-pouch', products: [8529633345583], gift: 47120364339247,
      sameSize: [47120364273711, 47120364306479, 47120364339247] },              /* any 15x20 colour */
    { id: 'set-pouch', products: [8529701470255, 8529701666863, 8529701765167], gift: 47061398585391,
      sameSize: [47061398519855, 47061398552623, 47061398585391] }               /* any 20x25 colour */
  ];
  var PROP = '_gift', SS_RELOAD = 'croPlusGiftReload';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);
  var busy = false, again = false;

  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function json(url, body) {
    return nativeFetch(root + url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cro-gift ' + url + ' ' + r.status); return r.json(); });
  }
  function state(cart, rule) {
    var trig = 0, same = 0, gifts = [];
    cart.items.forEach(function (i) {
      if (rule.products.indexOf(i.product_id) > -1) trig += i.quantity;
      if (rule.sameSize.indexOf(i.variant_id) > -1) same += i.quantity;
      if (i.properties && i.properties[PROP] === rule.id) gifts.push({ key: i.key, qty: i.quantity });
    });
    return { trig: trig, same: same, gifts: gifts };
  }
  function change(key, qty) { return json('cart/change.js', { id: key, quantity: qty }); }
  function kDeclined(r) { return r.id === 'plus-pouch' ? 'croPlusGiftDeclined' : 'croGiftDeclined-' + r.id; }
  function kLast(r) { return r.id === 'plus-pouch' ? 'croPlusGiftLast' : 'croGiftLast-' + r.id; }

  /* One rule against a fresh cart. Resolves to true if the cart was changed. */
  function applyRule(rule) {
    var changed = false;
    return json('cart.js').then(function (cart) {
      var s = state(cart, rule), last = ss(kLast(rule));
      if (last === 'trig+gift' && s.trig > 0 && s.gifts.length === 0) ss(kDeclined(rule), '1');
      if (s.trig === 0) ss(kDeclined(rule), null);
      var p = Promise.resolve();
      if (s.trig === 0 && s.gifts.length) {
        s.gifts.forEach(function (g) { p = p.then(function () { changed = true; return change(g.key, 0); }); });
      } else if (s.trig > 0) {
        s.gifts.forEach(function (g, n) {
          var want = n === 0 ? 1 : 0;
          if (g.qty !== want) p = p.then(function () { changed = true; return change(g.key, want); });
        });
        if (s.same === 0 && !ss(kDeclined(rule))) {
          var props = {}; props[PROP] = rule.id;
          p = p.then(function () { changed = true; return json('cart/add.js', { items: [{ id: rule.gift, quantity: 1, properties: props }] }); });
        }
      }
      return p.then(function () { return changed ? json('cart.js') : cart; }).then(function (c2) {
        var s2 = state(c2, rule); ss(kLast(rule), s2.trig > 0 ? (s2.gifts.length ? 'trig+gift' : 'trig') : 'none');
        return { changed: changed, cart: c2 };
      });
    });
  }

  function reconcile() {
    if (busy) { again = true; return Promise.resolve(false); }
    busy = true;
    var any = false, lastCart = null, p = Promise.resolve();
    RULES.forEach(function (r) { p = p.then(function () { return applyRule(r).then(function (res) { if (res.changed) any = true; lastCart = res.cart; }); }); });
    return p.then(function () {
      if (any) document.dispatchEvent(new CustomEvent('cro:plus-gift:changed', { detail: { cart: lastCart } }));
      return any;
    }).catch(function (e) { if (window.console) console.warn(e && e.message ? e.message : e); return false; })
      .then(function (ch) { busy = false; if (again) { again = false; return reconcile().then(function (c) { return ch || c; }); } return ch; });
  }

  function onCartPage() { return /\/cart\/?$/.test(location.pathname); }
  function refreshIfNeeded(changed) {
    if (!changed) return;
    if (onCartPage()) {
      var n = parseInt(ss(SS_RELOAD) || '0', 10);
      if (n < 3) { ss(SS_RELOAD, String(n + 1)); location.reload(); }
    } else {
      json('cart.js').then(function (c) {
        document.querySelectorAll('a[href$="/cart"][aria-label^="Cart"]').forEach(function (a) { a.setAttribute('aria-label', 'Cart, ' + c.item_count + ' items'); });
        document.querySelectorAll('[data-cart-count], .hu-cart-count, .cart-count-bubble span[aria-hidden]').forEach(function (el) { el.textContent = c.item_count; });
      }).catch(function () {});
    }
  }

  /* Watch any cart write made through fetch (theme cart page, apps). */
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var res = nativeFetch(input, init);
    if (CART_WRITE.test(url)) {
      res.then(function () { setTimeout(function () { reconcile().then(refreshIfNeeded); }, 0); }, function () {});
    }
    return res;
  };

  /* Product form of a trigger product (main button and sticky bar both submit the form): add, apply the gift, then go to the cart like the native form. */
  function ruleForProduct(pid) { for (var i = 0; i < RULES.length; i++) { if (RULES[i].products.indexOf(pid) > -1) return RULES[i]; } return null; }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[action*="/cart/add"]') || e.defaultPrevented) return;
    var pid = f.querySelector('input[name="product-id"]');
    var rule = pid && ruleForProduct(parseInt(pid.value, 10));
    if (!rule) return;
    e.preventDefault();
    var fid = f.getAttribute('id');
    var btns = Array.prototype.slice.call(f.querySelectorAll('button[type="submit"]'));
    if (fid && window.CSS && CSS.escape) btns = btns.concat(Array.prototype.slice.call(document.querySelectorAll('button[type="submit"][form="' + CSS.escape(fid) + '"]')));
    btns.forEach(function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
    var fd = new FormData(f);
    nativeFetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
      .then(function () { ss(kDeclined(rule), null); return reconcile(); })
      .then(function () { location.href = root + 'cart'; })
      .catch(function () { btns.forEach(function (b) { b.disabled = false; b.removeAttribute('aria-busy'); }); HTMLFormElement.prototype.submit.call(f); });
  }, false);

  /* On every page load (covers native /cart/add, /cart/change links and other tabs). */
  function boot() { reconcile().then(function (ch) { if (!ch) ss(SS_RELOAD, null); refreshIfNeeded(ch); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
